module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_LT-0be39b4cd47a723287dc60bc408860a5.svg";